import { Col, Row } from "antd";
import { createUseStyles } from "react-jss";
import { Link } from "react-router-dom";
import { useAuthContext } from "../core/contexts/AuthContextProvider";
import HeaderMenu from "../core/headerMenu/headerMenu";
import NavMenu from "../core/navMenu/navMenu";
import { ROUTES } from "../core/navigation";
import { _STYLES } from "./utils/customStyles";

const {
  textMd1,
  h100,
  dashboardContainer,
  dashboardInner,
  dashboardMid,
  dashboardWrap,
  dashLeft,
  dashHeader,
  dashRight,
  link,
  navLogo,
} = _STYLES;

const useStyles = createUseStyles({
  dashboardContainer,
  dashboardInner,
  textMd1,
  dashboardWrap,
  dashboardMid,
  dashLeft,
  h100,
  dashHeader,
  dashRight,
  link,
  navLogo,
});

const ContentWrapper = ({ children }) => {
  const classes = useStyles();
  const path = window.location.pathname;

  const { isLoadingRoute } = useAuthContext();

  if (path.includes(ROUTES.login) || isLoadingRoute()) {
    return children;
  }

  return (
    <>
      <Row className={classes.dashboardWrap}>
        <Col className={classes.dashboardContainer} xs={24}>
          <Row className={classes.dashboardInner}>
            <Col xs={24}>
              <Row className={classes.h100}>
                <Col className={classes.dashLeft} xs={3}>
                  <Link className={classes.link} to={ROUTES.dashboard}>
                    <div className={classes.dashHeader}>
                      <img
                        alt="logo"
                        className={classes.navLogo}
                        src="/logo_min.png"
                      />
                    </div>
                  </Link>

                  <NavMenu />
                </Col>
                <Col xs={21}>
                  <HeaderMenu />
                  <Row>
                    <Col className={classes.dashboardMid} xs={24}>
                      {children}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ContentWrapper;
